export default {
  APP_ENV: import.meta.env.VITE_APP_ENV ? String(import.meta.env.VITE_APP_ENV) : 'production',
  PERSIST_STORE_ENABLED: Number(import.meta.env.VITE_PERSIST_STORE_ENABLED) === 1,
  // BASE_URL is the Vite `base` ('/static/'); strip the trailing slash so the
  // existing `${PUBLIC_URL}/path` templates resolve without a double slash.
  PUBLIC_URL: import.meta.env.BASE_URL.replace(/\/$/, ''),
  GTM_ID: import.meta.env.VITE_GTM_ID ? String(import.meta.env.VITE_GTM_ID) : '',
}
